import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';

import { Textarea } from '../../components/utils/Input';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import validateManyFields from '../../validations';
import AILightComponent from '../../components/AILightComponent';
import '../../styles/Concerns.css';
import { GenerateApplauseCode } from '../../components/GenerateThink5whysCode';

const Applause = () => {

  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { applauseId } = useParams();

  const mode = applauseId === undefined ? "add" : "update";
  const [applause, setApplause] = useState(null);

  const [formErrors, setFormErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [countFormErrors, setCountFormErrors] = useState(0);

  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [nameCodeVerified, setNameCodeVerified] = useState(false);
  const [nameCodeStatus, setNameCodeStatus] = useState(false);
  const [nameCodeStatusMsg, setNameCodeStatusMsg] = useState(false);
  const [error, setError] = useState(null);
  
  const [marksheetMegaPrizes, setMarksheetMegaPrizes] = useState(false);

  const [nameCodeId, setNameCodeId] = useState('');
  const [name, setName] = useState('');

  const autoApplauseCode = GenerateApplauseCode();
  const [formData, setFormData] = useState({
    user: "",
    userName: authState.user.name,
    applauseTo: "",
    applauseFor: "",
    title: "",
    applauseDate: new Date(),
    description: "",
    name: "",
    tags: "",
    isActive: true,
    isDeleted: false,
    remarks: "",
    nameCode: '',
    applauseCode: autoApplauseCode,
    reply: "",
    replyDate: null,
    isMarksheetMegaPrize: false,
    overallMarks: 0,
    favSubject: '',
    subjectMarks: 0,
    dateMarksheet: null,
    isAgreed: false,
    influencerCode: "",
    instagramId: "",
    applauseGroupCode: "",
  });

  useEffect(() => {
    document.title = mode === "add" ? "Add Applause" : "Update Applause";
  }, [mode]);


  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/applause/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {applauseId: applauseId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false }).then((data) => {
        // console.log("response for update - ",data.applause);
        // console.log("response ",data.applause.applauseDate);
        setApplause(data.applause);
        setFormData({ 
          user: data.applause.user,
          userName: data.applause.userName,
          applauseTo: data.applause.applauseTo,
          applauseFor: data.applause.applauseFor,
          title: data.applause.title,
          applauseDate: new Date(data.applause.applauseDate),
          description: data.applause.description,
          name: data.applause.name,
          tags: data.applause.tags,
          isActive: data.applause.isActive,
          isDeleted: data.applause.isDeleted,
          remarks: data.applause.remarks,
          nameCode: data.applause.nameCode, 
          applauseCode: data.applause.applauseCode,
          reply: data.applause.reply,
          replyDate: data.applause.replyDate,
          isMarksheetMegaPrize: data.applause.isMarkesheetMegaPrize,
          overallMarks: data.applause.overallMarks,
          favSubject: data.applause.favSubject,
          subjectMarks: data.applause.subjectMarks,
          dateMarksheet: data.applause.dateMarksheet,
          isAgreed: data.applause.isAgreed,
          influencerCode: data.applause.influencerCode,
          instagramId: data.applause.instagramId,
          applauseGroupCode: data.applause.applauseGroupCode,
        });
      });
    }
  }, [mode, authState, applauseId, fetchData]);



  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/applause", 
        method: "post", 
        data: {formData: formData, user: authState.user._id},
        headers: { Authorization: authState.token } 
      };
      fetchData(config).then(() => {
        navigate("/i-applauded");
      });
    }
    else {
      const config = { 
        url: `/applause/${applauseId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      fetchData(config).then(() => {
        navigate("/i-applauded");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.applauseTo) {
      errors.applauseTo = "Please select an applausee";
    }
    if (!formData.applauseFor) {
      errors.applauseFor = "Please select an reason";
    }
    if (!formData.title) {
      errors.title = "Title is required";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.name) {
      errors.name = "Name is required";
    } else if (formData.name.length > 100) {
      errors.title = "Name cannot exceed 100 characters";
    }    
    if (!formData.description) {
      errors.description = "Description is required";
    } else if (formData.description.length > 2000) {
      errors.description = "Description cannot exceed 2000 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleMicrophoneClick = () => {
    setShowMicrophoneAlert(true);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  
const [nameCodeVerifyClicked, setNameCodeVerifyClicked] =useState(false);

const handleNameCodeVerifyClick = () => {
  // console.log("handleNameCodeVerifyClick", formData);
  setError("");
  setNameCodeVerifyClicked(true);
  
  // Validate Payee Code
  if (/^TU[a-zA-Z0-9]{12}$/.test(formData.nameCode)) {
        fetchNameCode(formData.nameCode);
  } else {
      setError('Please enter a valid 14-character Think5Whys user code starting with TU.');
  }
};


const fetchNameCode = useCallback((nameCode) => {
  // console.log("fetchNameCode for API call ", nameCode);
  const config = {
      url: "/auth/verifycodeforapplause",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: nameCode }
  };

  fetchData(config)
      .then(response => {
        // console.log("API Response: ", response); 
          if (response && response.status) {
              // console.log("Aplausee found ", response);
              setNameCodeStatus(true);
              setNameCodeId(response.t5wcode._id);
              setName(response.t5wcode.name);
              // Update formData.name with the response name
              setFormData(prevFormData => ({
                ...prevFormData,
                name: response.t5wcode.name
              }));
              setNameCodeStatusMsg("Code found. 😊");
              // console.log("Payee Code found");
          } else {
              // console.log("Code Not found else");
              setNameCodeStatus(false);
              setNameCodeStatusMsg(`Code ${payeeCode} not found! 😔 Make sure the Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("Code Not found! catch", error);
          setNameCodeStatus(false);
          setNameCodeStatusMsg("Think5Whys Code Not Found!! Please input correct code.");
      });
}, [fetchData, authState.token]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchNameCode]);

  return (
    <>
      <div className='bg-black'>
        <div className="min-h-full py-2 bg-black border-b border-blue-400">
          <h3 className='text-xl lg:text-2xl font-bold text-white text-center mb-1'>👏👏 Applause / GoodJob</h3>
          {loading ? (
            <Loader />
          ) : (
            <div className='text-m'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-lg lg:text-xl text-yellow-200">{mode === "add" ? "Add New Applause" : "Edit Applause"}</h2>
              </div>
              <div className="border-container">
                  <div className="mb-1">
                      <p className="text-yellow-300">Your Appaluse Code: {autoApplauseCode}</p>
                  </div>
                  <div className="flex flex-col justify-start items-start gap-2">
                    <label className='text-sm lg:text-m'>
                      <input className="mr-2" type="checkbox" checked={isCheckedAISupport} onChange={(e) => setIsCheckedAISupport(!isCheckedAISupport)} />
                      I want to take Gen AI Support in generating my AI Prompt or getting response from ChatGPT as Think5Whys AI partner. 
                    </label>
                  </div>
              </div>
              <div className="border-container">
                <div className="mb-4">
                  <label className="text-sm lg:text-m"  htmlFor="applauseTo">Applause To:*</label>
                  <br />
                  <select name="applauseTo" id="applauseTo" value={formData.applauseTo}
                    onChange={handleChange} className='text-sm' style={{ border: '1px solid #ccc', height: '48px', padding: '8px' }}>
                    <option value="">Select Whom to Applause</option>
                    <option value="Self">Self</option>
                    <option value="Mother">Mother</option>
                    <option value="Father">Father</option>
                    <option value="Parent">Parent</option>
                    <option value="Child">Child</option>
                    <option value="Sibling">Sibling</option>
                    <option value="Kin">Kin/Relative</option>
                    <option value="Grand Parent">Grand Parent</option>
                    <option value="In-laws">In-laws</option>
                    <option value="Friend">Friend</option>
                    <option value="Student">Student</option>
                    <option value="Teacher">Teacher</option>
                    <option value="Employee">Employee</option>
                    <option value="Team-Member">Team Member</option>
                    <option value="Employer">Employer/Boss</option>
                    <option value="Boss">Boss</option>
                    <option value="Others">Others</option>
                  </select>
                  {fieldError("applauseTo")}
                </div>
                <div className="border-container flex flex-col text-white">
                  <p className='text-sm lg:text-m'>Input Person Think5Whys User Code*:</p>
                  <p className='text-yellow-200 text-xs lg:text-sm py-2'>(Ask the person's 14 character User Code availabe on the Dashbaord) </p>
                  <input
                    type="text"
                    className="profile-input text-black py-2 px-4 "
                    style={{ width: '200px'}}
                    value={formData.nameCode}
                    onChange={(e) => setFormData({ ...formData, nameCode: e.target.value })}
                    placeholder="Input Code here"
                  />
                   {/* {!nameCodeStatus && ( */}
                   <div className="mb-6 text-center">
                    <p className={nameCodeStatus ? "text-green-500 text-lg" : "text-red-500 text-lg"}>
                      {nameCodeStatusMsg}
                    </p>
                  </div>
                  {/* )} */}
                  <div className='flex flex-row gap-2'>
                    <button
                      className='bg-orange-700 py-2 px-4 text-sm lg:text-m w-full lg:w-80'
                      onClick={()=>handleNameCodeVerifyClick()}
                      disabled={nameCodeStatus}
                    >
                      {nameCodeStatus ? "Think5Whys Code Validated" : "Validate Think5Whys Code"}
                    </button>
                    <button
                      onClick={handleCancelClick}
                      className="w-full lg:w-40 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded text-sm lg:text-m"
                    >
                      Back
                    </button>
                  </div>
                  <div className="text-center mb-6">
                    <p className={nameCodeStatus ? "text-green-400" : "text-red-400"}>
                      <strong className="text-xl">{setNameCodeStatusMsg}</strong>
                    </p>
                  </div>
                  {setNameCodeStatus && (
                      <div className='mb-4'>
                        <p className="text-sm lg:text-m text-white">
                          Name: 
                          <span className="text-yellow-300 text-lg">
                            {mode==="add" ? name : formData.name}
                          </span>
                        </p>
                      </div>
                  )}
                </div>
                <div className="mb-4">
                  <label className="text-sm lg:text-m"  htmlFor="applauseFor">Applause For:*</label>
                  <br />
                  <select name="applauseFor" id="applauseFor" value={formData.applauseFor}
                    onChange={handleChange} className='text-sm' style={{ border: '1px solid #ccc', height: '48px', padding: '8px' }}>
                      <optgroup label="General">
                          <option value="Community Service or Volunteering">Community Service or Volunteering</option>
                          <option value="Consistency in Study or Work Habits">Consistency in Study or Work Habits</option>
                          <option value="Creative Challenges">Creative Challenges</option>
                          <option value="Daily Physical Activity">Daily Physical Activity</option>
                          <option value="Daily Self-Reflection or Journaling">Daily Self-Reflection or Journaling</option>
                          <option value="Effective Time Management">Effective Time Management</option>
                          <option value="Financial Health Discussions">Financial Health Discussions</option>
                          <option value="Goal Tracking and Achievement">Goal Tracking and Achievement</option>
                          <option value="Habit Building">Habit Building</option>
                          <option value="Other - General">Other - General</option>
                          <option value="Outdoor Recreation and Exploration">Outdoor Recreation and Exploration</option>
                          <option value="Personal Skill Development">Personal Skill Development</option>
                          <option value="Public Speaking or Presentation">Public Speaking or Presentation</option>
                          <option value="Random Act of Kindness">Random Act of Kindness</option>
                      </optgroup>

                      <optgroup label="Families">
                          <option value="Community Event Participation">Community Event Participation</option>
                          <option value="Cooking Together as a Family">Cooking Together as a Family</option>
                          <option value="Educational Trips">Educational Trips</option>
                          <option value="Family Game Night">Family Game Night</option>
                          <option value="Family Movie Night">Family Movie Night</option>
                          <option value="Family Sports or Fitness Routine">Family Sports or Fitness Routine</option>
                          <option value="Family Story Sharing">Family Story Sharing</option>
                          <option value="Gardening or Planting Together">Gardening or Planting Together</option>
                          <option value="Healthy Cooking and Nutrition">Healthy Cooking and Nutrition</option>
                          <option value="Home Improvement Projects">Home Improvement Projects</option>
                          <option value="Outdoor Family Adventure">Outdoor Family Adventure</option>
                          <option value="Other - Family">Other - Family</option>
                          <option value="Weekly Family Fitness Challenge">Weekly Family Fitness Challenge</option>
                      </optgroup>

                      <optgroup label="Learning & Development">
                          <option value="Book Reading Challenges">Book Reading Challenges</option>
                          <option value="Career Exploration or Skill Research">Career Exploration or Skill Research</option>
                          <option value="Creative Skill Building">Creative Skill Building</option>
                          <option value="Daily Reading or Learning">Daily Reading or Learning</option>
                          <option value="Language Learning">Language Learning</option>
                          <option value="Marks">Marks</option>
                          <option value="Online Course Completion">Online Course Completion</option>
                          <option value="Other - Learning & Development">Other - Learning & Development</option>
                          <option value="Problem-Solving Activities (puzzles, logic games)">Problem-Solving Activities (puzzles, logic games)</option>
                          <option value="Project-Based Learning (group projects)">Project-Based Learning (group projects)</option>
                          <option value="Quiz or Competition Participation">Quiz or Competition Participation</option>
                          <option value="Science Experiments or STEM Activities">Science Experiments or STEM Activities</option>
                          <option value="Study Groups or Peer Learning">Study Groups or Peer Learning</option>
                          <option value="Public Speaking or Presentation Practice">Public Speaking or Presentation Practice</option>
                      </optgroup>

                      <optgroup label="Friends">
                          <option value="Adventure Exploration">Adventure Exploration</option>
                          <option value="Cultural or Learning Challenge">Cultural or Learning Challenge</option>
                          <option value="Game Nights">Game Nights</option>
                          <option value="Group Fitness Challenge">Group Fitness Challenge</option>
                          <option value="Movie Marathons">Movie Marathons</option>
                          <option value="Network Building or Social Networking">Network Building or Social Networking</option>
                          <option value="Outdoor Picnic or Beach Day">Outdoor Picnic or Beach Day</option>
                          <option value="Other - Friends">Other - Friends</option>
                          <option value="Team Building or Escape Room Events">Team Building or Escape Room Events</option>
                          <option value="Team-Based Creative Projects">Team-Based Creative Projects</option>
                          <option value="Volunteering or Charity Activities Together">Volunteering or Charity Activities Together</option>
                          <option value="Weekly Book Club">Weekly Book Club</option>
                          <option value="Weekly Sports Meetup">Weekly Sports Meetup</option>
                      </optgroup>

                      <optgroup label="Office / Work Related">
                          <option value="Constructive Feedback and Appreciation">Constructive Feedback and Appreciation</option>
                          <option value="Creativity or Innovation Sessions">Creativity or Innovation Sessions</option>
                          <option value="Face-to-Face Reconnect Activities">Face-to-Face Reconnect Activities</option>
                          <option value="Group Problem-Solving Activities">Group Problem-Solving Activities</option>
                          <option value="Mentorship or Knowledge Sharing Programs">Mentorship or Knowledge Sharing Programs</option>
                          <option value="Networking or Social Events">Networking or Social Events</option>
                          <option value="Other - Office / Work">Other - Office / Work</option>
                          <option value="Peer Recognition and Applause">Peer Recognition and Applause</option>
                          <option value="Project Hackathons or Sprints">Project Hackathons or Sprints</option>
                          <option value="Regular Wellness Breaks">Regular Wellness Breaks</option>
                          <option value="Step or Fitness Challenges">Step or Fitness Challenges</option>
                          <option value="Team Building Exercises">Team Building Exercises</option>
                          <option value="Team Sports or Fitness Breaks">Team Sports or Fitness Breaks</option>
                      </optgroup>

                      <optgroup label="Self Activities">
                          <option value="Building Positive Habits">Building Positive Habits</option>
                          <option value="Daily Gratitude Practice">Daily Gratitude Practice</option>
                          <option value="Daily Reading or Knowledge Building">Daily Reading or Knowledge Building</option>
                          <option value="Daily Reflection or Journaling">Daily Reflection or Journaling</option>
                          <option value="Financial Planning or Budgeting">Financial Planning or Budgeting</option>
                          <option value="Goal Setting and Tracking">Goal Setting and Tracking</option>
                          <option value="Healthy Eating Planning">Healthy Eating Planning</option>
                          <option value="Learning a New Skill">Learning a New Skill</option>
                          <option value="Mindfulness or Meditation Practice">Mindfulness or Meditation Practice</option>
                          <option value="Other - Self">Other - Self</option>
                          <option value="Personal Creative Projects">Personal Creative Projects</option>
                          <option value="Physical Fitness Routine">Physical Fitness Routine</option>
                          <option value="Self-Improvement Challenges">Self-Improvement Challenges</option>
                          <option value="Social Media Detox">Social Media Detox</option>
                      </optgroup>

                      <optgroup label="Social">
                          <option value="Attending Community Events">Attending Community Events</option>
                          <option value="Community Talent Show or Open Mic">Community Talent Show or Open Mic</option>
                          <option value="Creativity Challenges">Creativity Challenges</option>
                          <option value="Cultural Events or Festival Celebrations">Cultural Events or Festival Celebrations</option>
                          <option value="Cultural Learning Experiences">Cultural Learning Experiences</option>
                          <option value="Group Dance Classes or Fitness Sessions">Group Dance Classes or Fitness Sessions</option>
                          <option value="Group Sports Activities">Group Sports Activities</option>
                          <option value="Hosting or Attending Dinner Parties">Hosting or Attending Dinner Parties</option>
                          <option value="Joining or Hosting a Book Club">Joining or Hosting a Book Club</option>
                          <option value="Neighborhood Meetups or Socials">Neighborhood Meetups or Socials</option>
                          <option value="Organizing Movie Nights">Organizing Movie Nights</option>
                          <option value="Participating in Support Groups">Participating in Support Groups</option>
                          <option value="Peer Support and Social Circles">Peer Support and Social Circles</option>
                          <option value="Volunteering or Charity Work">Volunteering or Charity Work</option>
                          <option value="Other - Social">Other - Social</option>
                      </optgroup>

                      <optgroup label="Cricket">
                          <option value="Analyzing Matches for Improvement">Analyzing Matches for Improvement</option>
                          <option value="Batting">Batting</option>
                          <option value="Batting Practice Sessions">Batting Practice Sessions</option>
                          <option value="Bowling">Bowling</option>
                          <option value="Bowling Practice Sessions">Bowling Practice Sessions</option>
                          <option value="Captaincy - on field">Captaincy - on field</option>
                          <option value="Cricket-Specific Fitness Training">Cricket-Specific Fitness Training</option>
                          <option value="Fielding">Fielding</option>
                          <option value="Fielding Drills and Exercises">Fielding Drills and Exercises</option>
                          <option value="Organising">Organising</option>
                          <option value="Other - Cricket">Other - Cricket</option>
                          <option value="Outreach Events for Youth Cricketers">Outreach Events for Youth Cricketers</option>
                          <option value="Scoring">Scoring</option>
                          <option value="Skill Challenges">Skill Challenges</option>
                          <option value="Studying Famous Matches Together">Studying Famous Matches Together</option>
                          <option value="Support">Support</option>
                          <option value="Team Bonding Activities">Team Bonding Activities</option>
                          <option value="Team Management">Team Management</option>
                          <option value="Tournament Planning and Strategy">Tournament Planning and Strategy</option>
                          <option value="Umpiring">Umpiring</option>
                          <option value="Weekly Cricket Matches">Weekly Cricket Matches</option>
                      </optgroup>

                      <optgroup label="Unspecified">
                          <option value="Others">Others</option>
                      </optgroup>
                  </select>
                  {fieldError("applauseFor")}
                </div>
                <div className="mb-4">
                  <label className="text-sm lg:text-m"  htmlFor="title">Heading / Title*:</label>
                  <br />
                  <input 
                    type="text" 
                    name="title" 
                    id="title" 
                    value={formData.title} 
                    placeholder="Enter the heading / title..."
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '80%' }} 
                  />
                  {fieldError("title")}
                </div> 
              </div>

              <div className="border-container">
              <label className="text-sm lg:text-m"  htmlFor="description">
                Description / Message*:
                  { showMicrophoneAlert && (
                    <span style={{ marginLeft: '8px', cursor: 'pointer' }} onClick={handleMicrophoneClick}>
                      <FontAwesomeIcon icon={faMicrophone} style={{ color: 'yellow' }} />
                    </span>
                  )}
              </label>
                <div className="mb-4">
                  <textarea 
                    type="description" 
                    name="description" 
                    id="description" 
                    value={formData.description}
                    placeholder={showMicrophoneAlert ? "Write here or Click Mic for Voice Input...":"Write here.."}
                    onChange={handleChange}
                    maxLength="2000"
                    style={{
                      border: '1px solid #ccc',
                      padding: '2px',
                      backgroundColor: '#f0f0f0', 
                      color: '#000000',
                      width: '100%', 
                      height: '150px' 
                    }}
                  />
                  {fieldError("description")}
                </div>
                {isCheckedAISupport && formData.description!== '' && (
                    <div className="mb-1">
                      <AILightComponent param1={"Applause "+formData.name+" for "} param2={formData.description}/>
                    </div>
                  )}
              </div>
              <div className="border-container">
                <div className="mb-4">
                  <label className="text-sm lg:text-m"  htmlFor="applauseGroupCode">Applause Group Code (To Pull Data For AI Counselling):</label>
                  <br />
                  <input 
                    type="text" 
                    name="applauseGroupCode" 
                    id="applauseGroupCode" 
                    value={formData.applauseGroupCode} 
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px' , width: '100%'}} 
                  />
                  {fieldError("applauseGroupCode")}
                </div>
              </div>
              <div className="border-container">
                <div className="mb-4">
                  <label className="text-sm lg:text-m"  htmlFor="tags">Other Comment / Tags / Keyword:</label>
                  <br />
                  <input 
                    type="text" 
                    name="tags" 
                    id="tags" 
                    value={formData.tags} 
                    placeholder=""
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px' , width: '100%'}} 
                  />
                  {fieldError("tags")}
                </div>
              </div>
            <div className="border-container flex flex-col justify-center">
              <div className="flex justify-center">
                {Object.keys(formErrors).length > 0 && (
                  <div className="form-errors text-red-300 justify-center items-center">
                    {Object.keys(formErrors).map((key) => (
                      <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                    ))}
                  </div>
                )}
              </div>
              <div className="flex justify-center">
                <button className='bg-blue-500 text-white px-4 py-2 font-medium hover:bg-primary-dark' onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}</button>
                <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate("/applause-hub-home")}>Cancel</button>
                {/* {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>} */}
              </div>
          </div>  
          </div>
          )}
        </div>
        <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/about-us" className="hover:text-teal-300">About</Link>
              <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
              <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
            </div>
          </div>
        </footer>        
      </div>
    </>
  )
}

export default Applause